import {Component, Inject, NgModule, OnInit} from '@angular/core';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {LinaUiModule} from '../lina-ui/lina-ui.module';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';

@Component({
  selector: 'lina-confirm-dialog',
  templateUrl: './templates/lina-confirm-dialog.component.html',
  styleUrls: ['./lina-generic-dialogs.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  body: string;
  htmlBody: string;
  title: string;
  theme: string;
  rejectButton: string;
  acceptButton: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ConfirmDialogComponent>) { }

  ngOnInit() {
    this.body = this.data.body;
    this.htmlBody = this.data.htmlBody;
    this.title = this.data.title;
    this.theme = this.data.theme || 'info';
    this.rejectButton = this.data.rejectButton || 'NO';
    this.acceptButton = this.data.acceptButton || 'YES';
  }

  onSubmit(confirm) {
    this.dialogRef.close(confirm);
  }
}

@Component({
  selector: 'lina-prompt-dialog',
  templateUrl: './templates/lina-prompt-dialog.component.html',
  styleUrls: ['./lina-generic-dialogs.component.scss']
})
export class PromptDialogComponent implements OnInit {
  title: string;
  body: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.title = this.data.title;
    this.body = this.data.body;
  }
}

@Component({
  selector: 'lina-prompt-input-dialog',
  templateUrl: './templates/lina-prompt-input-dialog.component.html',
  styleUrls: ['./lina-generic-dialogs.component.scss']
})
export class PromptInputDialogComponent implements OnInit {
  title: string;
  body: string;
  htmlBody: string;
  placeholder: string;
  input: string;
  type: string;
  inputMode: string;
  inputForm: FormGroup;
  textarea: boolean;
  infoMessage: string;
  required: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<PromptInputDialogComponent>,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.title = this.data.title;
    this.body = this.data.body;
    this.htmlBody = this.data.htmlBody;
    this.placeholder = this.data.placeholder;
    this.input = this.data.input;
    this.type = this.data.type ?? 'email';
    this.inputMode = this.data.inputMode ?? 'text';
    this.textarea = this.data.textarea;
    this.infoMessage = this.data.infoMessage;
    this.required = this.data.required !== undefined ? this.data.required : true;

    this.inputForm = this.fb.group({
      Input: [this.input || '', this.required ? Validators.required : undefined]
    });
  }

  onSubmit() {
    var inputValue = this.inputForm.value.Input.replaceAll('\n', '<br>');
    this.dialogRef.close(inputValue !== '' ? inputValue : null);        
  }
}

@NgModule({
  imports: [
    CommonModule,
    LinaUiModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  exports: [ConfirmDialogComponent, PromptDialogComponent, PromptInputDialogComponent],
  declarations: [ConfirmDialogComponent, PromptDialogComponent, PromptInputDialogComponent]
})
export class LinaGenericDialogsModule {}
